import { Business } from "api/gen/entities";
import { createContext } from "react";

const BusinessContext = createContext<Business | null>(null)

export default BusinessContext;